import format from 'utilities/format'

export const formatDate = (date: Date) => `${format(date, 'PP HH:mm')}`
